/**
 * Side-effect module: leaves for the demo host before anything else in the
 * bundle runs. Imported first in index.tsx, ahead of the stylesheet and React,
 * so /demo never paints the marketing layout.
 */
const DEMO_URL = 'https://demo.lentic.ai'

export function isDemoPath(): boolean {
  if (typeof window === 'undefined') return false
  const path = window.location.pathname
  return path === '/demo' || path === '/demo/'
}

if (isDemoPath()) {
  window.location.replace(DEMO_URL)
}
